const API_BASE_URL = `${process.env.REACT_APP_CRM_ENDPOINT_URL}/en/api/v1.0`;

export const kcbService = {
    /**
     * Lấy lịch sử khám bệnh theo mã KCB và mã đăng ký
     * @param {string} makcb - Mã khám bệnh
     * @param {string} mandk - Mã đăng ký
     * @returns {Promise<Object>} Dữ liệu lịch sử khám bệnh
     */
    async getLichSuKCB(makcb, mandk) {
        if (!makcb || !mandk) {
            throw new Error('Mã KCB và mã đăng ký là bắt buộc');
        }

        try {
            const response = await fetch(
                `${API_BASE_URL}/KetQuaCdha/get-ls-kcb?makcb=${makcb}&mandk=${mandk}`
            );

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            return result;
        } catch (error) {
            console.error("Lỗi fetch dữ liệu lịch sử KCB:", error);
            throw error;
        }
    },

    /**
     * Lấy thông tin chi tiết của một lượt khám
     * @param {Array} luotKhamList - Danh sách lượt khám
     * @param {string} maKcb - Mã KCB cần tìm
     * @returns {Object|null} Thông tin lượt khám hoặc null nếu không tìm thấy
     */
    getLuotKhamById(luotKhamList, maKcb) {
        return luotKhamList?.find(item => item.maKcb === maKcb) || null;
    },

    /**
     * Lọc danh sách chẩn đoán hình ảnh
     * @param {Array} canLamSangList - Danh sách cận lâm sàng
     * @returns {Array} Danh sách chẩn đoán hình ảnh
     */
    filterCdha(canLamSangList) {
        return canLamSangList?.filter(item => item.isXetNghiem === false) || [];
    },

    /**
     * Lọc danh sách xét nghiệm
     * @param {Array} canLamSangList - Danh sách cận lâm sàng
     * @returns {Array} Danh sách xét nghiệm
     */
    filterXetNghiem(canLamSangList) {
        return canLamSangList?.filter(item => item.isXetNghiem === true) || [];
    }
};
